import React from 'react';
import { useTranslation } from 'react-i18next';
import { ParticipantFieldType, Participation } from '@app/api';
import { TableParticipationHeader } from '../../components/TableParticipationHeader';
import { Filter } from '../../components/Filter';
import { TableParticipationStatusList } from '../../components/TableParticipationStatusList';
import { TableDeclinedReasonList } from '../../components/TableDeclinedReasonList';
import { TextLoadingPlaceholder } from '@app/core';
import { useParticipationTableContext } from './ParticipationTableContext';
import { TableColumnHeader } from './TableColumnHeader';

export const StatusHeader = () => {
  const { t } = useTranslation();
  const { session, filtering, special } = useParticipationTableContext();

  const statusFieldKey = special.status?.fieldKey || 'status';
  const statusList = special.status?.statusList || [];
  const haveDeclinedReason = special.status?.haveDeclinedReason || false;
  const statusFieldValues = special.status?.fieldValues || [];

  return (
    <th key="status">
      <TableColumnHeader>
        <TableParticipationHeader
          fieldKey={statusFieldKey}
          fieldType={ParticipantFieldType.SHORT_TEXT}
        >
          <span>
            {t('sessions.details.participantsDetails.columns.status')}
          </span>
        </TableParticipationHeader>
        {((statusList.length > 1 && !haveDeclinedReason) ||
          haveDeclinedReason) && (
          <Filter
            fieldRef={statusFieldKey}
            fieldLabel={t(
              'sessions.details.participantsDetails.columns.status',
            )}
            fieldType={ParticipantFieldType.TAGS}
            fieldValues={statusFieldValues}
            sessionId={session.id}
            currentFilterData={filtering.getFieldCurrentFilter(statusFieldKey)}
            onFilterDataChange={filtering.handleFilterChange}
          />
        )}
      </TableColumnHeader>
    </th>
  );
};

export const StatusCell = ({
  participation,
}: {
  participation: Participation;
}) => {
  const { session, special } = useParticipationTableContext();
  const haveDeclinedReason = special.status?.haveDeclinedReason || false;

  return (
    <td key="status">
      {!haveDeclinedReason ? (
        <TableParticipationStatusList
          participation={participation}
          sessionId={session.id}
        />
      ) : (
        <TableDeclinedReasonList participation={participation} />
      )}
    </td>
  );
};

export const StatusLoader = () => {
  const { t } = useTranslation();
  return (
    <td key="status">
      <TextLoadingPlaceholder
        sample={t('sessions.details.participantsDetails.columns.status')}
      />
    </td>
  );
};
